import * as React from "react";
import Manage from "../../assets/icons/tickCircle.svg";
import Icon from "./Icon";

const FavoritesIcon = () => {
    var smallStyle = {
        height: 48,
        margin: "0px 8px 0px 0px" 
    }; 

  return (
    <React.Fragment>
          <Icon icon={Manage} text="Tick" id="tickIcon" style={smallStyle} tooltip={true}/>
    </React.Fragment>
  );
};

export default FavoritesIcon;
